// @flow

import { find, first } from 'lodash';

import { PathColors } from '@zapier/editor/src/theme';

/*
   Get color pair (name and value), or default to first color in list
   if not found.
 */
export const getPathColorValue = (color: ?string) =>
  find(PathColors, ({ name }) => name === color) || first(PathColors);

/*
   Given a path color name, return rgb color style value.
 */
export const getPathColorStyle = (color: ?string) => {
  const c = getPathColorValue(color);
  return `rgb(${c.value.join(', ')})`;
};
